import {
  Component,
  inject,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { DestroyBase } from '../../../../../shared/base-classes/destroy-component-base';
import { CdfiOutreachLogsService } from '../../services/cdfi-outreach-logs.service';
import { CDFIOutreachStats } from '../../models/cdfi-outreach-stats';
import { OutreachFormType } from '../../../../outreach/models/outreach-form-data';
import { takeUntil } from 'rxjs';

@Component({
  selector: 'app-cdfi-outreach-logs-dashboard',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './cdfi-outreach-logs-dashboard.component.html',
  styleUrl: './cdfi-outreach-logs-dashboard.component.scss',
})
export class CdfiOutreachLogsDashboardComponent
  extends DestroyBase
  implements OnChanges
{
  @Input({ required: true }) outreachType!: OutreachFormType;
  @Input() source?: string;

  loading = true;
  cdfiOutreachStats!: CDFIOutreachStats;

  cdfiOutreachLogsService = inject(CdfiOutreachLogsService);

  ngOnChanges(changes: SimpleChanges): void {
    if (
      (changes['outreachType'] || changes['source']) &&
      this.outreachType !== undefined
    ) {
      this.loading = true;
      this.cdfiOutreachLogsService
        .getCdfiOutreachStats(this.outreachType, this.source)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (response) => {
            this.cdfiOutreachStats = response;
            this.loading = false;
          },
          error: () => {
            this.loading = false;
          },
        });
    }
  }
}
